import React from 'react';
import { NavLink } from 'react-router-dom';
import { House, Path, Gear } from '@phosphor-icons/react';

const items = [
  { to: '/', label: 'Home', icon: House, id: 'nav-home' },
  { to: '/treks', label: 'My Treks', icon: Path, id: 'nav-treks' },
  { to: '/settings', label: 'Settings', icon: Gear, id: 'nav-settings' },
];

export default function BottomNav() {
  return (
    <nav
      data-testid="bottom-nav"
      className="glass-panel fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-[460px] z-40 border-t border-white/10 safe-bottom"
    >
      <ul className="grid grid-cols-3">
        {items.map(({ to, label, icon: Icon, id }) => (
          <li key={to}>
            <NavLink
              end={to === '/'}
              to={to}
              data-testid={id}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center gap-1 py-3 btn-tap ${
                  isActive ? 'text-[#FF9F1C]' : 'text-zinc-400'
                }`
              }
            >
              <Icon size={22} weight="bold" />
              <span className="text-[11px] font-medium tracking-wide uppercase">{label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
